// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5a868027","977":"7e746eb5"}[chunkId] + ".chunk.js";
};